const mapStyles = [{"featureType":"all","elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#000000"},{"lightness":40}]},{"featureType":"all","elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#000000"},{"lightness":16}]},{"featureType":"all","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#000000"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#000000"},{"lightness":17},{"weight":1.2}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":20}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":21}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#000000"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#000000"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":16}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":19}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":17}]}];

let infowindows = [];
let markers = [];
let map;

// offset map centre: https://gist.github.com/msherstobitow/524412b3c8555166ca25

google.maps.Map.prototype.setCenterWithOffset= function(latlng, offsetX, offsetY) {
    var map = this;
    var ov = new google.maps.OverlayView();
    ov.onAdd = function() {
        var proj = this.getProjection();
        var aPoint = proj.fromLatLngToContainerPixel(latlng);
        aPoint.x = aPoint.x+offsetX;
        aPoint.y = aPoint.y+offsetY;
        map.setCenter(proj.fromContainerPixelToLatLng(aPoint));
    }; 
    ov.draw = function() {}; 
    ov.setMap(this); 
};

class SingleMap  {
	
	constructor() {
		this.mapEvents();
	}

	mapEvents() {
		if (document.getElementById('map-canvas')) {
			var self = this;
			self.initMap();
		}
        $('.contact__address a').on('click',function(e){
            e.preventDefault();
            let index = $('.contact__address a').index($(this));
            $.each(infowindows,function(index,item){
                item.close();
            });
            infowindows[index].open(map, markers[index]);
            map.setZoom(11);
            map.panTo(markers[index].position);
        });
	}

	initMap(coords, mapId) {
        let bounds = new google.maps.LatLngBounds();

        if (locs != undefined) {
            let lat = $(".bjzm-single-map__canvas").data('lat');
            let lng = $(".bjzm-single-map__canvas").data('lng');
            let centerLatlng = new google.maps.LatLng(lat, lng);


            let canadaCenter = new google.maps.LatLng(49.797389, -98.266974);
            

            if( $(window).outerWidth() > 768 ) {
                // centerLatlng = loc1;
            }

            let mapOptions = {
                zoom: 13,
                // center: centerLatlng,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                zoomControl: true,
                scrollwheel: false,
                mapTypeControl: false,
                rotateControl: false,
                fullscreenControl: false,
                streetViewControl: false,
                styles: mapStyles
            };

            map = new google.maps.Map(document.getElementById("map-canvas"), mapOptions);

            let mapPosition = { lat: lat, lng: lng };
            /* customize the map marker */
            let customMarker = `${BJZM_DATA.assets_url}/map-icon.png` ;
            var icon = {
                url: customMarker,
                scaledSize: new google.maps.Size(30, 44),
                anchor: new google.maps.Point(25, 60)
            };

            $.each(locs,function(index,item){
                let loc = new google.maps.LatLng(item.loc[0], item.loc[1]);
                bounds.extend(loc);
                markers[index] = new google.maps.Marker({
                    position: loc,
                    map: map,      
                    icon: icon,
                    jIndex: index,
                });
                infowindows[index] = new google.maps.InfoWindow({
                    content: '<h3 style="margin-bottom:8px;">'+item.title+'</h3>'+item.address
                });
                markers[index].addListener('click', function() {
                    map.setZoom(11);
                    map.panTo(this.position);
                    $.each(infowindows,function(index,item){
                        item.close();
                    });
                    infowindows[this.get('jIndex')].open(map, this);
                });
            });

            var listener = google.maps.event.addListener(map, "idle", function() { 
              if (map.getZoom() > 13) map.setZoom(13); 
              google.maps.event.removeListener(listener); 
            });

            map.setCenterWithOffset(canadaCenter, 0,  -15);

            map.fitBounds(bounds);

            

        } else {
            alert('locs undefined!');
        }
	}

}

module.exports = SingleMap;